import { SectionLoader } from '@/shared/components/section-loader';

export const ScheduledAdminLoading = () => {
  return <SectionLoader />;
};
